/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class ApiService {
    public static config(Restangular: Restangular.IService): any {
        return Restangular.withConfig((config: any) => {

            config.setBaseUrl('/api');

            config.setDefaultHttpFields({
                timeout: 90000
            });
            /*
            config.setResponseExtractor(function(res, op) {
                if (op === 'getList') {
                    var items = res.items;

                    // May be a string coz relations
                    if (angular.isString(items)) {
                        items = angular.fromJson(items);
                    }

                    items.count = res.count;
                    items.$$meta = res.meta;

                    return items;
                } else {
                    return res;
                }
            });*/
        });
    }
}

ApiService.config.$inject = ['Restangular'];

angular.module('beneple.global').factory('Api', ApiService.config);



// WEBPACK FOOTER //
// ./frontend/scripts/global/services/api.service.ts